import { Store } from 'vuex';

import { AppState } from '@/store';
import { MUTATIONS as UI_MUTATIONS } from '@/store/ui';
import { UiService } from '../ui/ui.service';

export interface BagService {
  toggleBagVisibility(): boolean;
  setBagVisibility(visible: boolean): boolean;
  setDataAnalyticsType(type?: string): void;
}

export class AppBagService implements BagService {
  constructor(private store: Store<AppState>, private ui: UiService) {}

  toggleBagVisibility() {
    const visible = this.getBagVisibility();

    return this.setBagVisibility(!visible);
  }

  setBagVisibility(visible: boolean) {
    this.store.commit(UI_MUTATIONS.SET_BAG_VISIBILITY, visible);
    this.ui.setAppScrollability(!visible);
    return this.getBagVisibility();
  }

  // Default to 'section'
  setDataAnalyticsType(type: string = 'section'): void {
    this.store.commit(UI_MUTATIONS.SET_BAG_DATA_ANALYTICS_TYPE, type);
  }

  private getBagVisibility(): boolean {
    return this.store.state.ui.bag.visible;
  }
}
